function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function subscriptionState(config, now = Date.now()) {
  const status = String(config?.subscription_status || "").toLowerCase();

  if (!status) return { status: "legacy", blocked: false, isTrial: false, daysLeft: null };

  if (status === "trial") {
    const end = parseDate(config?.trial_ends_at);
    const expired = !end || end.getTime() <= now;
    const daysLeft = end && !expired ? Math.max(1, Math.ceil((end.getTime() - now) / 86400000)) : 0;
    return { status, blocked: expired, isTrial: true, expired, daysLeft, trialEndsAt: end };
  }

  if (status === "active" || status === "internal") {
    return { status, blocked: false, isTrial: false, daysLeft: null };
  }

  if (status === "cancelled") {
    const accessUntil = parseDate(config?.subscription_access_until);
    const stillActive = Boolean(accessUntil && accessUntil.getTime() > now);
    return {
      status,
      blocked: !stillActive,
      isTrial: false,
      daysLeft: null,
      accessUntil,
    };
  }

  return {
    status,
    blocked: ["payment_pending", "expired", "past_due"].includes(status),
    isTrial: false,
    daysLeft: null,
  };
}

